import {SafetyTaskProps} from "./SafetyPlay";
import Puzzle from "../../Shared/Components/Puzzle";
import {useEffect} from "react";

export default function SafetyPuzzle(props: SafetyTaskProps) {

    useEffect(() => {
        props.onLoaded()
    }, [])

    return <Puzzle solve={props.solve} imageSource={props.task.picture} onComplete={() => {
        props.onFinish(true)
    }}/>

}